import * as React from 'react';

import OddsRange from '@/components/elements/Text/OddsRange';
import SetNumber from '@/components/elements/Text/SetNumber';
import PurchasedCount from '@/components/layouts/Modal/BetPanel/Partials/TicketBox/Singlerace/Pertials/PurchasedCount';
import RefundRange from '@/components/layouts/Modal/BetPanel/Partials/TicketBox/Singlerace/Pertials/RefundRange';
import { BetDetail, OddsData, Ticket } from '@/modelTypes';

import { Detail, DetailWrapper } from './style';

interface ConfirmProps {
  betDetail: BetDetail;
  oddsData: OddsData;
}

const Confirm: React.FC<ConfirmProps> = ({ betDetail, oddsData }) => {
  const arrayOfSetNum = (tickets: Ticket[]) => tickets.map(t => t.setNum);

  return (
    <DetailWrapper>
      <Detail>
        <p>買い目</p>
        <SetNumber
          setNums={arrayOfSetNum(betDetail.tickets)}
          firstThreeRacerList={betDetail.firstThreeRacerList}
          betType={betDetail.betType}
        />
      </Detail>
      <Detail>
        <p>口数</p>
        <PurchasedCount tickets={betDetail.tickets} />
      </Detail>
      <Detail>
        <p>オッズ</p>
        <OddsRange
          odds={oddsData.exists ? oddsData.data : null}
          setNums={arrayOfSetNum(betDetail.tickets)}
          betType={betDetail.betType}
        />
      </Detail>
      <Detail>
        <p>想定払戻金額</p>
        <RefundRange
          setNums={arrayOfSetNum(betDetail.tickets)}
          betType={betDetail.betType}
          count={betDetail.tickets[0].count}
          odds={oddsData.exists ? oddsData.data : null}
        />
      </Detail>
    </DetailWrapper>
  );
};

export default Confirm;
